'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _models = require('../../models');

var _common = require('../common');

var _commonFormsy = require('../common-formsy');

var _constants = require('../../constants');

var _TermsTable = require('./TermsTable');

var _TermsTable2 = _interopRequireDefault(_TermsTable);

var _LegalFundingLienModalFormGroup = require('./LegalFundingLienModalFormGroup');

var _LegalFundingLienModalFormGroup2 = _interopRequireDefault(_LegalFundingLienModalFormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_ACTIONS = _constants.AppConstants.LIEN_ACTIONS,
    MODAL_TITLE = {
  create: 'Generate Contract',
  edit: 'Edit Contract',
  finalize: 'Finalize Contract',
  revise: 'Revise Contract',
  view: 'Contract Details'
},
    MODAL_BUTTON = {
  create: 'Generate Contract',
  edit: 'Save',
  finalize: 'Finalize',
  revise: 'Save',
  view: 'Close'
};

var LegalFundingLienModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'LienStore', 'PriorFundingStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(LegalFundingLienModal, _Component);

  function LegalFundingLienModal(props) {
    _classCallCheck(this, LegalFundingLienModal);

    var _this = _possibleConstructorReturn(this, (LegalFundingLienModal.__proto__ || Object.getPrototypeOf(LegalFundingLienModal)).call(this, props));

    _initDefineProp(_this, 'loading', _descriptor, _this);

    _initDefineProp(_this, 'submitErrors', _descriptor2, _this);

    _initDefineProp(_this, 'priorFunding', _descriptor3, _this);

    _initDefineProp(_this, 'errorMessage', _descriptor4, _this);

    _initDefineProp(_this, 'lien', _descriptor5, _this);

    _this.presets = [];

    if (!props.lienId) {
      _this.lien = new _models.LienModel();
    }
    return _this;
  }

  _createClass(LegalFundingLienModal, [{
    key: 'fetch',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, _case, application, lienId, LienStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, application = _props.application, lienId = _props.lienId, LienStore = _props.LienStore;


                this.loading = true;
                _context.next = 4;
                return LienStore.fetchPresets();

              case 4:
                this.presets = _context.sent;

                if (!lienId) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return LienStore.retrieve(lienId, 'legal-funding', {});

              case 8:
                this.lien = _context.sent;

              case 9:

                if ((0, _get3.default)(application, 'prior_funding')) {
                  this.priorFunding = (0, _find3.default)(_case.prior_fundings, { id: (0, _get3.default)(application, 'prior_funding.id') });
                }

                this.loading = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch() {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.fetch();
    }
  }, {
    key: 'publishedOrSelectedPresets',
    value: function publishedOrSelectedPresets() {
      var allPresets = this.presets || [];
      var displayPresets = allPresets.filter(function (p) {
        return p.is_published;
      });

      return displayPresets;
    }
  }, {
    key: 'onFormChange',
    value: function onFormChange(data) {
      if (!this.loading) {
        var model = this.refForm.getModel();
        if (this.lien.preset_contract_template !== model.preset_contract_template) {
          var preset = (0, _find3.default)(this.presets, { id: model.preset_contract_template });
          this.lien.applyPreset(preset);
        }
        this.lien.extend((0, _omit3.default)(model, 'prior_funding'));

        if (model.prior_funding) {
          (0, _mobx.extendObservable)(this.priorFunding, model.prior_funding);
        }
      }
    }
  }, {
    key: 'addBuyout',
    value: function addBuyout() {
      this.priorFunding = {
        buyout_amount: '',
        expiration_date: '',
        funder_name: ''
      };
    }
  }, {
    key: 'onValidSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(model, resetForm, invalidateForm) {
        var _props2, _case, CaseStore, currentAction, LienStore, PriorFundingStore, UiStore, lienData, lien;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseStore = _props2.CaseStore, currentAction = _props2.currentAction, LienStore = _props2.LienStore, PriorFundingStore = _props2.PriorFundingStore, UiStore = _props2.UiStore;


                this.loading = true;
                this.errorMessage = null;
                this.lien.fees = (0, _mobx.toJS)(this.lien.fees).filter(function (fee) {
                  return fee.fee_type && fee.fee_amount;
                });

                _context2.prev = 4;
                lienData = _extends({}, this.lien.serialize(), currentAction === LIEN_ACTIONS.finalize && { is_confirmed: true });
                _context2.next = 8;
                return LienStore.upsertLegalFundingLien({
                  caseId: _case.id,
                  data: lienData,
                  lienId: this.lien.id
                });

              case 8:
                lien = _context2.sent;

                if (!this.priorFunding) {
                  _context2.next = 13;
                  break;
                }

                this.priorFunding.link_lien = lien.id;
                _context2.next = 13;
                return PriorFundingStore.create(_case, this.priorFunding);

              case 13:

                // Download new contract
                if (![LIEN_ACTIONS.finalize, LIEN_ACTIONS.revise].includes(currentAction)) {
                  CaseStore.onCaseLienContractDownloadClick(lien.contract_download_url, _case.id);
                }
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](4);

                this.errorMessage = 'An error occured saving contract info.';
                return _context2.abrupt('return');

              case 20:

                // Changes the state of ApplicationStatusCell > StatusActions
                if (currentAction === LIEN_ACTIONS.finalize) {
                  UiStore.modals.LegalFundingLien.finalize();
                }

                // Close modal if no errors
                !this.errorMessage && UiStore.modals.LegalFundingLien.close();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 16]]);
      }));

      function onValidSubmit(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'handleSubmitErrorsChange',
    value: function handleSubmitErrorsChange(submitErrors) {
      this.submitErrors = submitErrors;
      this.loading = false;
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'renderBodyLeft',
    value: function renderBodyLeft() {
      var _props3 = this.props,
          application = _props3.application,
          currentAction = _props3.currentAction,
          showOnly = currentAction === LIEN_ACTIONS.view;


      return _react2.default.createElement(_LegalFundingLienModalFormGroup2.default, {
        addBuyout: this.addBuyout,
        application: application,
        currentAction: currentAction,
        errorMessage: this.errorMessage,
        lien: this.lien,
        priorFunding: this.priorFunding,
        publishedOrSelectedPresets: this.publishedOrSelectedPresets,
        showOnly: showOnly
      });
    }
  }, {
    key: 'renderBodyRight',
    value: function renderBodyRight() {
      var terms = this.lien.terms;


      if (!terms || !terms.length) {
        return null;
      }

      return _react2.default.createElement(_TermsTable2.default, { lien: this.lien, presets: this.presets });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (this.loading) {
        return _react2.default.createElement(_common.Loader, { className: 'modal-loader' });
      }

      return _react2.default.createElement(
        _Grid2.default,
        { className: 'col-wrapper', fluid: true },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-left', lg: 5, md: 5, sm: 12, xs: 12 },
            this.renderBodyLeft()
          ),
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-right', lg: 7, md: 7, sm: 12, xs: 12 },
            this.renderBodyRight()
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          currentAction = _props4.currentAction,
          UiStore = _props4.UiStore,
          showOnly = currentAction === LIEN_ACTIONS.view,
          title = MODAL_TITLE[currentAction],
          buttonText = MODAL_BUTTON[currentAction],
          onClose = UiStore.modals.LegalFundingLien.close;


      return _react2.default.createElement(
        _Modal2.default,
        {
          show: true,
          onHide: onClose,
          className: 'modal-caselien right side-modal large two-col' },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            disabled: showOnly,
            onChange: this.onFormChange,
            onSubmitErrorsChange: this.handleSubmitErrorsChange,
            onValidSubmit: this.onValidSubmit,
            ref: this.setRefForm },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              title
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              !showOnly && _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: this.loading || this.submitErrors, bsStyle: 'primary', type: 'submit' },
                buttonText
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LegalFundingLienModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  application: _propTypes2.default.object,
  CaseStore: _propTypes2.default.object.isRequired,
  currentAction: _propTypes2.default.oneOf(Object.keys(LIEN_ACTIONS)).isRequired,
  lienId: _propTypes2.default.string,
  LienStore: _propTypes2.default.object.isRequired,
  PriorFundingStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'submitErrors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'priorFunding', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'errorMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'lien', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onValidSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onValidSubmit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LegalFundingLienModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_ACTIONS, 'LIEN_ACTIONS', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(MODAL_TITLE, 'MODAL_TITLE', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(MODAL_BUTTON, 'MODAL_BUTTON', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(LegalFundingLienModal, 'LegalFundingLienModal', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LegalFundingLienModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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